import * as React from 'react';
import { Toast, ToastType } from '../../Components';
import styled from 'styled-components';

interface IProps {
  messages: string[] | undefined;
}

const StyledItem = styled.div`
  padding: 5px;
`;

export const GlobalErrorToast: React.FC<IProps> = ({ messages }: IProps) => {
  return messages && messages.filter(m => m).length > 0 ?
    <Toast type={ToastType.error}>
      {messages.filter(m => m).map((m, idx) => <StyledItem key={idx}>{m}</StyledItem>)}
    </Toast>
    : <></>;
};